import axios from 'axios';
import { downloadDocumentApi } from 'reactApp/api/axios.corsapi';
import { IS_STOCK } from 'reactApp/appHelpers/configHelpers';

import { sendMyofficeGa } from './sendMyofficeGa';

export const downloadDocument = async (url: string): Promise<{ content?: string | null; error?: unknown }> => {
    try {
        let content;

        if (IS_STOCK) {
            const { data: response } = await axios.get(url, {
                withCredentials: true,
                params: { no_redirect: true },
                responseType: 'arraybuffer',
            });
            content = response;
        } else {
            const { data: response } = await axios.get(url, { withCredentials: true, params: { no_redirect: true } });
            const { data: file } = await axios.get(response.redirect, { responseType: 'arraybuffer' });
            content = file;
        }

        sendMyofficeGa('download-success');

        return { content };
    } catch (error) {
        sendMyofficeGa('download-error');

        return { error };
    }
};

export const downloadDocumentMail = async (url?: string): Promise<{ content?: string | null; error?: unknown }> => {
    if (!url) {
        return {};
    }

    try {
        const { data: content } = await downloadDocumentApi(url);

        sendMyofficeGa('download-success');
        return { content };
    } catch (error) {
        sendMyofficeGa('download-error');
        return { error };
    }
};
